module.exports = __webpack_public_path__ + "static/img/main_logistics_bg.7685d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/main_logistics_bg.png
// module id = gOew
// module chunks = 44